import { Injectable } from '@angular/core';
import { Dimension } from '../../models/analytics-api/schema.model';
import { Slice } from '../../models/analytics-api/query_result.model';
import { Match } from '../../models/analytics-api/search_result.model';
import { QueryFilter } from '../../models/query-filter.model';
// import { QueryFilter, Dimension, Slice, Match } from '../../models/';
import { IMigrationDataType, IVersioningData } from '../../interfaces/migration.interface';
import { MigrationService } from './migration.service';

@Injectable()
export class QueryMigrationService {
  constructor(private migrationService: MigrationService) {}

  private versioningData: IVersioningData[] = [
    {
      version: 1,
      upgrade: function (data) {
        if (data && !!data.dimensions) {
          return data.dimensions.reduce((filterTotal: any[], dimension: Dimension) => {
            if (!!data.selection[dimension.name] && data.selection[dimension.name].length) {
              data.selection[dimension.name] = data.selection[dimension.name].map((match: Match) => {
                return new Match(
                  match.slices ? match.slices.map(slice => slice[dimension.name]).toString() : match.slice,
                  match.value,
                  match.slices
                )
              });

              filterTotal.push({
                expressions: [
                  new QueryFilter({
                    type: 'any',
                    key: dimension.name,
                    values: data.selection[dimension.name],
                    dimension: dimension,
                    is_searchable: dimension.isSearchable
                  })
                ]
              });
            }
            return filterTotal;
          }, []);
        }
        return [];
      }
    }
  ]

  public get currentVersion() {
    return this.versioningData[this.versioningData.length - 1].version;
  }

  public migrate(data: IMigrationDataType): any {
    return this.migrationService.migrate(data, this.versioningData);
  }

  public getQueryMigrationData(query): IMigrationDataType {
    return {
      version: query.version || 0,
      data: {
        dimensions: query.dimensions,
        selection: query.selection
      }
    };
  }

}
